module.exports = __webpack_public_path__ + "static/media/adult1.1de18a11.jpg";